

















import Vue from 'vue';
import { BROADCAST } from '@/mass/models/Broadcast';
import massVuex from '../../vuex/common';

export default Vue.extend({
  mixins: [massVuex],
  data() {
    return {
      BROADCAST,
    };
  },
  methods: {
    updateTimeType(timeType: number) {
      this.$store.commit('UPDATE_TIME_TYPE', timeType);
    },
  },
});
